import { brands } from "@/mocks/homeData";

export default function Brands() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100 border-y border-background-200/60">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14 reveal">
          <p className="text-foreground-500 text-sm font-medium uppercase tracking-wide">
            Trabajamos con las mejores marcas del mercado
          </p>
          <p className="text-foreground-700 text-base md:text-lg font-semibold mt-2">
            Venta de equipos con precios de mayorista
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16">
          {brands.map((brand, i) => (
            <div
              key={i}
              className="reveal transition-opacity duration-300"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-28 md:w-36 h-12 md:h-16 flex items-center justify-center">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}